// LICENSE_CODE ZON
'use strict'; /*jslint react:true es6:true*/

export const SELECTION_KIND = {
    EXTERNAL: 'external',
    SINGLE: 'single',
    MULTIPLE: 'multiple',
    ALL: 'all',
};
export const MAX_LOG_SIZE = 5;
